import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { useAuth } from "../../context/AuthContext";
import ROUTES from "../../routes/routePaths";

const RedirectAfterLogin = () => {
  const { admin } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!admin) return;

    const permissions = admin.permissions;

    const permissionToRoute = {
      MAP: ROUTES.HOME,
      DRIVERS: ROUTES.DRIVERS,
      USERS: ROUTES.CUSTOMERS,
      DRIVER_ACTIONS: ROUTES.REQUESTS,
      BALANCES: ROUTES.BALANCES,
      ADMIN_ACCOUNT: ROUTES.ACCOUNTS,
    };

    for (const permission of permissions) {
      if (permissionToRoute[permission]) {
        navigate(permissionToRoute[permission]);
        return;
      }
    }

    navigate(ROUTES.UNAUTHORIZED);
  }, [admin, navigate]);
};

export default RedirectAfterLogin;
